var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from "vue-property-decorator";
import InstructionsBase from "@/template/views/InstructionsBase";
import BasicInfoInstructions from "@/template/components/instructions/investmentReport/BasicInfoInstructions.vue";
import { InvestmentReportType } from "@/common/types/InvestmentReportType";
import PremisesFinancesInstructions from "@/template/components/instructions/investmentReport/PremisesFinancesInstructions.vue";
import IctFinancesInstructions from "@/template/components/instructions/investmentReport/ICTFinancesInstructions.vue";
import SupportApartmentsFinancesInstructions from "@/template/components/instructions/investmentReport/SupportApartmentsFinancesInstructions.vue";
var InvestmentReportInstructions = /** @class */ (function (_super) {
    __extends(InvestmentReportInstructions, _super);
    function InvestmentReportInstructions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(InvestmentReportInstructions.prototype, "reportType", {
        get: function () {
            if (this.metaType == "finalreport") {
                return InvestmentReportType.FinalReport;
            }
            else if (this.metaType == "budgetaryestimate") {
                return InvestmentReportType.BudgetaryEstimate;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvestmentReportInstructions.prototype, "InvestmentReportType", {
        get: function () {
            return InvestmentReportType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InvestmentReportInstructions.prototype, "title", {
        get: function () {
            if (this.reportType)
                return "InvestmentReport." + InvestmentReportType[this.reportType].toString();
            return null;
        },
        enumerable: false,
        configurable: true
    });
    InvestmentReportInstructions = __decorate([
        Component({
            name: "InvestmentReportInstructions",
            components: {
                BasicInfoInstructions: BasicInfoInstructions,
                PremisesFinancesInstructions: PremisesFinancesInstructions,
                IctFinancesInstructions: IctFinancesInstructions,
                SupportApartmentsFinancesInstructions: SupportApartmentsFinancesInstructions
            }
        })
    ], InvestmentReportInstructions);
    return InvestmentReportInstructions;
}(InstructionsBase));
export default InvestmentReportInstructions;
